import { render, staticRenderFns } from "./uniapp.vue?vue&type=template&id=4fec859e&"
import script from "./uniapp.vue?vue&type=script&lang=js&"
export * from "./uniapp.vue?vue&type=script&lang=js&"
import style0 from "./uniapp.vue?vue&type=style&index=0&id=4fec859e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports